"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import SelectCustomControlled from "./SelectCustomControlled.js";
const SelectCustomUncontrolled = (props) => {
    const { defaultValue, onChange, multiple, ...controlledProps } = props;
    const [value, setValue] = React.useState(defaultValue || (multiple ? [] : ""));
    return (
    // @ts-expect-error -- avoid complicating the types and implementation
    _jsx(SelectCustomControlled, { ...controlledProps, multiple: multiple, value: value, 
        // @ts-expect-error -- avoid complicating the types and implementation
        onChange: (args) => {
            setValue(args.value);
            onChange?.(args);
        } }));
};
SelectCustomUncontrolled.displayName = "SelectCustomUncontrolled";
export default SelectCustomUncontrolled;
